// src/MyComponent.js

import React from 'react';

const LeftImage = () => {
  return (
    <div className='col-xl-7 col-lg-6 col-sm-12 col-12 image-login'>
    <svg
      width='558'
      height='440'
      viewBox='0 0 558 440'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M35.9277 66.2109V298.592H210.403V68.3952'
        stroke='#002346'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M28.2988 18.3828V62.3255C28.2988 62.3255 47.8475 78.717 83.8521 64.4839C83.8521 64.4839 115.849 81.9128 159.734 67.0483C159.734 67.0483 195.564 80.3793 219.887 63.06V18.3828C219.887 18.3828 28.9431 19.0271 28.2988 18.3828Z'
        stroke='#002346'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M28.2988 48.3574C28.2988 48.3574 44.6259 65.8314 83.8521 50.9605C83.8521 50.9605 118.446 67.6613 159.747 52.8419C159.747 52.8419 189.772 69.1496 219.25 49.4012'
        stroke='#002346'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M28.2988 54.1562C28.2988 54.1562 44.6259 71.6302 83.8521 56.7593C83.8521 56.7593 118.446 73.4601 159.747 58.6407C159.747 58.6407 189.772 74.9485 219.25 55.2'
        stroke='#002346'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M51.9512 70.3223V275.004'
        stroke='#002346'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M99.6309 70.9648V275.002'
        stroke='#002346'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M194.346 72.2539V274.358'
        stroke='#002346'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M149.244 70.3223V275.004'
        stroke='#002346'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M52.2734 83.8262H194.217'
        stroke='#002346'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M52.2734 143.748H194.217'
        stroke='#002346'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M52.2734 211.402H194.217'
        stroke='#002346'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M35.9277 298.592L52.2033 275.119H194.598L210.403 298.592'
        stroke='#002346'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M518.711 94.625H332.232C326.258 94.625 321.414 99.4684 321.414 105.443V230.712C321.414 236.687 326.258 241.53 332.232 241.53H518.711C524.686 241.53 529.53 236.687 529.53 230.712V105.443C529.53 99.4684 524.686 94.625 518.711 94.625Z'
        fill='white'
        stroke='#002346'
        strokeMiterlimit='10'
      />
      <path
        d='M529.53 105.443V125.552H321.414V105.443C321.414 99.4703 326.259 94.625 332.232 94.625H518.711C524.684 94.625 529.53 99.4703 529.53 105.443Z'
        fill='#B274F5'
        stroke='#002346'
        strokeMiterlimit='10'
      />
      <path
        d='M488.614 114.277C490.927 114.277 492.802 112.401 492.802 110.088C492.802 107.775 490.927 105.9 488.614 105.9C486.301 105.9 484.426 107.775 484.426 110.088C484.426 112.401 486.301 114.277 488.614 114.277Z'
        fill='white'
        stroke='#002346'
        strokeMiterlimit='10'
      />
      <path
        d='M501.501 114.277C503.814 114.277 505.689 112.401 505.689 110.088C505.689 107.775 503.814 105.9 501.501 105.9C499.188 105.9 497.312 107.775 497.312 110.088C497.312 112.401 499.188 114.277 501.501 114.277Z'
        fill='white'
        stroke='#002346'
        strokeMiterlimit='10'
      />
      <path
        d='M514.387 114.277C516.7 114.277 518.575 112.401 518.575 110.088C518.575 107.775 516.7 105.9 514.387 105.9C512.074 105.9 510.199 107.775 510.199 110.088C510.199 112.401 512.074 114.277 514.387 114.277Z'
        fill='white'
        stroke='#002346'
        strokeMiterlimit='10'
      />
      <path
        d='M380.046 180.321C380.046 185.404 378.358 190.108 375.516 193.877C371.399 199.341 364.859 202.872 357.495 202.872C350.13 202.872 343.59 199.341 339.473 193.877C336.631 190.108 334.943 185.404 334.943 180.321C334.943 167.866 345.04 157.77 357.495 157.77C369.949 157.77 380.046 167.866 380.046 180.321Z'
        fill='white'
        stroke='#002346'
        strokeMiterlimit='10'
      />
      <path
        d='M375.516 193.878C371.399 199.341 364.859 202.872 357.494 202.872C350.13 202.872 343.59 199.341 339.473 193.878C339.788 184.2 347.739 176.455 357.494 176.455C367.249 176.455 375.2 184.2 375.516 193.878Z'
        fill='#FBE493'
        stroke='#002346'
        strokeMiterlimit='10'
      />
      <path
        d='M357.817 180.32C362.621 180.32 366.516 176.426 366.516 171.622C366.516 166.818 362.621 162.924 357.817 162.924C353.014 162.924 349.119 166.818 349.119 171.622C349.119 176.426 353.014 180.32 357.817 180.32Z'
        fill='#FBE493'
        stroke='#002346'
        strokeMiterlimit='10'
      />
      <path
        d='M504.078 144.238H400.986C397.606 144.238 394.865 146.979 394.865 150.359C394.865 153.74 397.606 156.48 400.986 156.48H504.078C507.458 156.48 510.199 153.74 510.199 150.359C510.199 146.979 507.458 144.238 504.078 144.238Z'
        fill='#E6E7E8'
        stroke='#002346'
        strokeMiterlimit='10'
      />
      <path
        d='M504.078 162.924H400.986C397.606 162.924 394.865 165.664 394.865 169.045C394.865 172.425 397.606 175.166 400.986 175.166H504.078C507.458 175.166 510.199 172.425 510.199 169.045C510.199 165.664 507.458 162.924 504.078 162.924Z'
        fill='#E6E7E8'
        stroke='#002346'
        strokeMiterlimit='10'
      />
      <path
        d='M504.078 183.541H400.986C397.606 183.541 394.865 186.282 394.865 189.662C394.865 193.043 397.606 195.783 400.986 195.783H504.078C507.458 195.783 510.199 193.043 510.199 189.662C510.199 186.282 507.458 183.541 504.078 183.541Z'
        fill='#E6E7E8'
        stroke='#002346'
        strokeMiterlimit='10'
      />
      <path
        d='M504.078 204.16H400.986C397.606 204.16 394.865 206.901 394.865 210.281C394.865 213.662 397.606 216.402 400.986 216.402H504.078C507.458 216.402 510.199 213.662 510.199 210.281C510.199 206.901 507.458 204.16 504.078 204.16Z'
        fill='#FBE493'
        stroke='#002346'
        strokeMiterlimit='10'
      />
      <path
        d='M431.941 381.721L436.29 385.303C437.372 386.192 437.759 387.694 437.218 388.989C435.285 393.641 429.267 404.291 413.32 409.826L413.217 400.96L431.934 381.721H431.941Z'
        fill='white'
        stroke='#002346'
        strokeMiterlimit='10'
      />
      <path
        d='M218.09 372.945L207.529 409.678H215.332L232.323 372.945H218.09Z'
        fill='#E6E7E8'
        stroke='#002346'
        strokeMiterlimit='10'
      />
      <path
        d='M330.118 370.195L336.091 406.928H328.281L315.885 370.195H330.118Z'
        fill='#E6E7E8'
        stroke='#002346'
        strokeMiterlimit='10'
      />
      <path
        d='M159.779 368.816L149.219 405.549H157.021L174.012 368.816H159.779Z'
        fill='#E6E7E8'
        stroke='#002346'
        strokeMiterlimit='10'
      />
      <path
        d='M399.447 380.298C399.447 380.298 400.826 378.919 404.499 380.755L412.011 383.384C413.081 383.758 414.234 383.796 415.323 383.487C418.583 382.566 425.948 380.691 430.445 381.129C432.237 381.303 433.409 383.094 432.842 384.801C431.599 388.545 427.713 395.639 415.594 402.32L393.945 396.367L391.651 393.609C391.651 393.609 389.815 389.015 392.108 387.179L399.454 380.291L399.447 380.298Z'
        fill='#B274F5'
        stroke='#002346'
        strokeMiterlimit='10'
      />
      <path
        d='M394.976 391.953C398.468 390.381 403.861 388.461 406.799 389.936C406.799 389.936 400.369 390.394 390.273 398.203C390.273 398.203 381.549 405.548 368.237 405.548C368.237 405.548 355.383 406.47 352.625 411.979L353.082 400.039L361.343 397.816C363.772 397.166 366.053 396.051 368.063 394.543L370.531 392.694L372.96 389.576C373.411 388.996 374.216 388.841 374.848 389.215L383.849 394.53C383.849 394.53 387.876 396.36 390.698 394.466C392.077 393.538 393.468 392.643 394.983 391.96L394.976 391.953Z'
        fill='#B274F5'
        stroke='#002346'
        strokeMiterlimit='10'
      />
      <path
        d='M360.717 378.127L370.524 392.689C370.524 392.689 369.145 404.628 353.076 400.034L347.109 387.637L360.717 378.127Z'
        fill='#F1B2C0'
        stroke='#002346'
        strokeMiterlimit='10'
      />
      <path
        d='M367.805 296.942L363.179 377.076H337.006L208.503 374.653L159.232 373.726C149.161 373.539 140.637 366.219 138.923 356.29L114.568 214.868C112.815 204.675 119.832 195.178 129.864 193.683C130.379 193.599 130.901 193.548 131.436 193.516L183.89 190.197L255.165 190.558C267.987 190.623 278.927 199.856 281.144 212.484L289.713 261.375L357.734 266.839C364.39 267.374 369.383 273.154 368.939 279.816L367.805 296.935V296.942Z'
        fill='#E6E7E8'
        stroke='#002346'
        strokeMiterlimit='10'
      />
      <path
        d='M337.045 275.254L366.851 363.307L337.464 380.297L298.934 279.777L337.045 275.254Z'
        fill='#FBE493'
        stroke='#002346'
        strokeMiterlimit='10'
      />
      <path
        d='M345.272 274.236L286.961 281.123L239.668 275.151L240.125 272.399L285.125 278.366L310.833 224.185L370.98 220.055L345.272 274.236Z'
        fill='white'
        stroke='#002346'
        strokeMiterlimit='10'
      />
      <path
        d='M240.189 272.38L274.106 263.211L287.425 266.426L290.182 267.805L285.131 278.365L240.196 272.405C240.196 272.405 240.183 272.386 240.196 272.38H240.189Z'
        fill='#E6E7E8'
        stroke='#002346'
        strokeMiterlimit='10'
      />
      <path
        d='M347.831 371.039L335.17 380.755L342.058 393.152L354.525 383.655L347.831 371.039Z'
        fill='white'
        stroke='#002346'
        strokeMiterlimit='10'
      />
      <path
        d='M368.688 386.721L371.903 390.851L372.94 389.356C373.41 388.886 374.138 388.796 374.712 389.131L383.842 394.524C383.842 394.524 388.436 396.818 391.645 393.603C391.645 393.603 389.808 389.93 392.102 387.172L399.447 380.284L387.437 372.166L368.688 386.715V386.721Z'
        fill='#F1B2C0'
        stroke='#002346'
        strokeMiterlimit='10'
      />
      <path
        d='M352.618 411.979C352.618 411.979 352.09 415.955 353.733 418.1L411.393 403.255L414.666 406.051C414.666 406.051 420.117 391.322 406.799 389.943C406.799 389.943 400.369 390.401 390.272 398.21C390.272 398.21 380.633 406.013 368.236 405.555C368.236 405.555 355.84 406.013 352.625 411.986L352.618 411.979Z'
        fill='#002346'
        stroke='#002346'
        strokeMiterlimit='10'
      />
      <path
        d='M161.158 267.806C161.158 267.806 189.624 268.263 196.054 308.669L208.509 374.66L159.238 373.732C149.167 373.545 140.643 366.226 138.929 356.297L114.213 215.049C112.35 204.398 120.095 194.463 130.881 193.683L145.101 192.652L161.164 267.806H161.158Z'
        fill='white'
        stroke='#002346'
        strokeMiterlimit='10'
      />
      <path
        d='M242.426 272.702L259.926 274.95C259.926 274.95 264.011 275.15 265.383 272.856L269.513 273.314C269.513 273.314 272.728 274.235 273.186 271.477L277.007 274.254C278.16 275.092 279.752 275.189 280.911 274.364C281.382 274.029 281.768 273.546 281.91 272.856C281.91 272.856 285.583 274.235 286.961 272.399L287.941 272.586L290.177 267.805L287.419 265.511H287.876C287.876 265.511 291.092 265.968 290.634 263.217L279.616 258.166C279.616 258.166 276.137 255.421 269.378 258.398C269.378 258.398 262.696 261.078 255.544 261.001L245.177 260.459C245.177 260.459 241.962 266.123 242.42 272.702H242.426Z'
        fill='#F1B2C0'
        stroke='#002346'
        strokeMiterlimit='10'
      />
      <path
        d='M290.176 267.806L294.77 258.624L279.615 246.227C279.615 246.227 280.601 239.668 277.856 235.422C276.594 233.47 275.717 231.299 275.46 228.992L272.728 203.992C272.728 203.992 270.891 191.138 258.495 184.708L245.028 175.275L231.401 177.82L218.547 171.854L200.641 179.199C200.641 179.199 183.193 185.629 176.305 200.777C176.305 200.777 169.417 214.095 174.011 237.052C174.011 237.052 175.848 244.855 173.09 252.664C173.09 252.664 171.254 260.931 174.926 264.603L193.753 263.225C193.753 263.225 216.71 260.467 226.813 277L242.883 276.543C242.883 276.543 241.046 267.819 245.177 260.473L257.116 260.931C257.116 260.931 263.546 260.473 268.591 258.637C268.591 258.637 275.021 255.422 279.609 258.18L290.627 263.231C290.627 263.231 291.432 265.667 287.412 265.525L290.169 267.819L290.176 267.806Z'
        fill='#B274F5'
        stroke='#002346'
        strokeMiterlimit='10'
      />
      <path
        d='M227.271 147.51C227.271 147.51 230.486 160.828 218.547 171.846L232.67 188.115C233.353 188.901 233.985 189.732 234.565 190.596L241.961 201.691C241.961 201.691 247.174 186.955 245.028 175.267L234.616 154.398L233.695 144.295L227.265 147.51H227.271Z'
        fill='#F1B2C0'
        stroke='#002346'
        strokeMiterlimit='10'
      />
      <path
        d='M263.456 141.31C264.835 133.542 259.656 126.127 251.889 124.748C244.121 123.368 236.706 128.547 235.327 136.315L232.346 153.101C230.966 160.868 236.145 168.283 243.912 169.663C251.68 171.042 259.095 165.864 260.475 158.096L263.456 141.31Z'
        fill='#F1B2C0'
        stroke='#002346'
        strokeMiterlimit='10'
      />
      <path
        d='M227.343 156.481V147.46L227.73 136.487C227.73 136.487 225.893 125.012 235.075 121.333C235.075 121.333 252.523 105.721 261.705 119.497C261.705 119.497 267.491 117.796 270.564 121.423C271.472 122.493 271.917 123.878 271.962 125.283C272.052 128.053 271.434 133.472 265.403 134.812C262.929 135.36 260.3 135.025 258.129 133.717C257.562 133.375 257.007 132.963 256.518 132.454C255.519 131.416 254.185 130.74 252.742 130.74C251.995 130.74 251.138 130.682 250.229 130.508C248.225 130.128 246.144 130.489 244.463 131.642L241.408 133.73C239.939 134.735 238.844 136.217 238.387 137.937C238.168 138.781 237.8 139.741 237.208 140.617C236.447 141.751 235.99 143.053 235.9 144.412C235.648 148.253 231.48 155.218 227.33 156.461L227.343 156.481Z'
        fill='#002346'
        stroke='#002346'
        strokeMiterlimit='10'
      />
      <path
        d='M235.048 149.862C236.664 149.862 237.973 148.114 237.973 145.957C237.973 143.801 236.664 142.053 235.048 142.053C233.433 142.053 232.123 143.801 232.123 145.957C232.123 148.114 233.433 149.862 235.048 149.862Z'
        fill='#F1B2C0'
        stroke='#002346'
        strokeMiterlimit='10'
      />
      <path
        d='M226.814 276.987C226.814 276.987 228.631 287.921 230.564 302.096L271.884 312.16C275.383 313.165 278.514 315.169 280.891 317.927C291.903 330.684 336.226 368.467 353.526 385.806L377.862 363.77L298.92 279.783L286.948 281.13L242.838 275.26L242.87 276.542L226.801 276.999L226.814 276.987Z'
        fill='#FBE493'
        stroke='#002346'
        strokeMiterlimit='10'
      />
      <path
        d='M350.781 386.722L360.717 396.167L388.886 370.652L379.247 361.471L350.781 386.722Z'
        fill='white'
        stroke='#002346'
        strokeMiterlimit='10'
      />
      <path
        d='M414.601 399.582C414.601 399.582 412.307 391.316 398.531 398.661C398.531 398.661 383.377 409.221 372.816 409.221C372.816 409.221 356.032 408.841 353.757 416.077C353.294 417.552 353.951 419.144 355.297 419.911C356.76 420.748 359.324 421.624 363.635 421.624C363.635 421.624 384.756 421.167 385.213 421.167C385.671 421.167 419.188 420.246 414.601 399.589V399.582Z'
        fill='white'
        stroke='#002346'
        strokeMiterlimit='10'
      />
      <path
        d='M248.604 135.862C253.942 135.862 258.269 133.699 258.269 131.03C258.269 128.361 253.942 126.197 248.604 126.197C243.267 126.197 238.939 128.361 238.939 131.03C238.939 133.699 243.267 135.862 248.604 135.862Z'
        fill='#002346'
        stroke='#002346'
        strokeMiterlimit='10'
      />
      <path
        d='M213.992 174.244L223.296 198.593L233.051 189.115'
        stroke='#002346'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M245.408 189.528L252.573 196.918L248.946 178.014'
        stroke='#002346'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M242.381 204.121V255.937'
        stroke='#002346'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M245.177 260.46L208.431 252.586C205.809 252.026 203.109 251.935 200.455 252.329L192.227 253.546'
        stroke='#002346'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M181.848 192.523C181.848 192.523 200.623 190.926 202.389 208.174'
        stroke='#002346'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M202.388 213.084L200.719 250.571'
        stroke='#002346'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M279.616 246.228L273.508 241.061'
        stroke='#002346'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M256.898 260.511C256.898 260.511 261.975 257.405 257.381 248.34C257.381 248.34 253.76 244.377 256.821 238.282L262.078 226.658L263.412 246.22C263.412 246.22 263.36 256.097 268.708 258.314'
        stroke='#002346'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M265.383 272.858C265.383 272.858 267.805 266.311 273.186 271.479'
        stroke='#002346'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M281.91 272.857L273.953 265.982'
        stroke='#002346'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M286.961 272.399L277.928 263.211'
        stroke='#002346'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M287.418 265.512L280.82 261.504'
        stroke='#002346'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M288.875 278.366L313.179 226.666'
        stroke='#002346'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M167.389 262.29L214.166 260.602C220.197 260.383 225.429 264.738 226.305 270.711L237.787 348.732C238.902 356.29 244.849 362.211 252.413 363.293L270.751 365.909'
        fill='#E6E7E8'
      />
      <path
        d='M167.389 262.29L214.166 260.602C220.197 260.383 225.429 264.738 226.305 270.711L237.787 348.732C238.902 356.29 244.849 362.211 252.413 363.293L270.751 365.909'
        stroke='#002346'
        strokeMiterlimit='10'
      />
      <path
        d='M265.821 205.867L262.799 223.863'
        stroke='#002346'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M158.767 367.468C158.896 368.976 159.095 370.677 159.385 372.41C159.385 372.41 165.493 352.423 185.57 355L181.627 346.315L178.367 343.055C171.821 346.457 165.48 345.432 161.151 354.214C159.127 358.312 158.374 362.919 158.773 367.474L158.767 367.468Z'
        fill='#7CD295'
        stroke='#002346'
        strokeMiterlimit='10'
      />
      <path
        d='M215.369 348.325C197.251 348.345 194.545 321.644 212.85 299.421C212.908 299.35 213.024 299.396 213.018 299.492C212.296 307.069 234.538 334.221 219.963 346.65C218.681 347.739 217.057 348.325 215.376 348.325H215.369Z'
        fill='#7CD295'
        stroke='#002346'
        strokeMiterlimit='10'
      />
      <path
        d='M214.274 338.352C202.844 331.567 205.421 311.226 239.293 299.223C239.358 299.203 239.422 299.261 239.396 299.319C239.01 300.421 236.767 307.618 235.588 327.927C235.273 333.339 227.541 346.226 214.274 338.346V338.352Z'
        fill='#7CD295'
        stroke='#002346'
        strokeMiterlimit='10'
      />
      <path
        d='M226.104 382.933C226.62 386.934 199.494 386.934 200.009 382.933C199.494 378.931 226.62 378.931 226.104 382.933Z'
        fill='#002346'
        stroke='#002346'
        strokeMiterlimit='10'
      />
      <path
        d='M227.174 418.371C226.002 418.197 196.131 418.88 196.06 417.817C190.178 415.027 189.926 405.916 189.926 405.916C189.037 393.758 200.01 387.237 200.01 387.237V382.939C199.494 386.941 226.62 386.941 226.105 382.939V387.533C240.467 396.96 237.554 417.417 227.174 418.371Z'
        fill='#B274F5'
        stroke='#002346'
        strokeMiterlimit='10'
      />
      <path
        d='M226.994 392.869C227.027 395.175 223.399 395.175 223.438 392.869C223.406 390.562 227.033 390.562 226.994 392.869Z'
        fill='white'
      />
      <path
        d='M232.328 398.21C232.361 400.517 228.733 400.517 228.772 398.21C228.74 395.904 232.367 395.904 232.328 398.21Z'
        fill='white'
      />
      <path
        d='M233.217 406.804C233.249 409.111 229.622 409.111 229.66 406.804C229.628 404.498 233.256 404.498 233.217 406.804Z'
        fill='white'
      />
      <path
        d='M228.475 413.332C228.507 415.638 224.88 415.638 224.918 413.332C224.886 411.025 228.514 411.025 228.475 413.332Z'
        fill='white'
      />
      <path
        d='M213.946 415.111C213.978 417.418 210.35 417.418 210.389 415.111C210.357 412.804 213.984 412.804 213.946 415.111Z'
        fill='white'
      />
      <path
        d='M202.678 413.332C202.71 415.638 199.083 415.638 199.121 413.332C199.089 411.025 202.717 411.025 202.678 413.332Z'
        fill='white'
      />
      <path
        d='M196.453 408.287C196.486 410.593 192.858 410.593 192.897 408.287C192.865 405.98 196.492 405.98 196.453 408.287Z'
        fill='white'
      />
      <path
        d='M197.342 398.21C197.374 400.517 193.747 400.517 193.785 398.21C193.753 395.904 197.381 395.904 197.342 398.21Z'
        fill='white'
      />
      <path
        d='M203.864 392.275C203.896 394.582 200.268 394.582 200.307 392.275C200.275 389.968 203.902 389.968 203.864 392.275Z'
        fill='white'
      />
      <path
        d='M209.797 397.617C209.829 399.923 206.202 399.923 206.241 397.617C206.208 395.31 209.836 395.31 209.797 397.617Z'
        fill='white'
      />
      <path
        d='M202.973 402.359C203.005 404.666 199.378 404.666 199.416 402.359C199.384 400.052 203.012 400.052 202.973 402.359Z'
        fill='white'
      />
      <path
        d='M208.909 408.287C208.941 410.593 205.313 410.593 205.352 408.287C205.32 405.98 208.947 405.98 208.909 408.287Z'
        fill='white'
      />
      <path
        d='M215.428 403.248C215.46 405.554 211.833 405.554 211.871 403.248C211.839 400.941 215.467 400.941 215.428 403.248Z'
        fill='white'
      />
      <path
        d='M216.614 393.164C216.646 395.47 213.018 395.47 213.057 393.164C213.025 390.857 216.652 390.857 216.614 393.164Z'
        fill='white'
      />
      <path
        d='M221.955 399.394C221.988 401.701 218.36 401.701 218.399 399.394C218.367 397.087 221.994 397.087 221.955 399.394Z'
        fill='white'
      />
      <path
        d='M226.104 403.544C226.136 405.851 222.509 405.851 222.547 403.544C222.515 401.238 226.143 401.238 226.104 403.544Z'
        fill='white'
      />
      <path
        d='M220.17 409.472C220.202 411.779 216.575 411.779 216.614 409.472C216.581 407.166 220.209 407.166 220.17 409.472Z'
        fill='white'
      />
      <path
        d='M242.116 362.92C232.335 354.957 218.431 365.891 232.329 379.525C232.329 379.525 239.448 386.045 242.412 392.868C242.412 392.868 256.053 383.081 256.349 369.737C256.349 369.737 256.349 356.097 242.116 362.914V362.92Z'
        fill='#7CD295'
        stroke='#002346'
        strokeMiterlimit='10'
      />
      <path
        d='M159.102 361.265C174.469 334.178 181.028 362.032 204.159 358.172C204.507 327.032 159.443 328.34 159.102 361.265Z'
        fill='#7CD295'
        stroke='#002346'
        strokeMiterlimit='10'
      />
      <path
        d='M200.01 387.236C200.01 387.236 210.957 392.855 226.105 387.533'
        stroke='#002346'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M215.803 372.861C215.803 372.861 222.246 345.8 238.644 358.924C240.951 360.767 242.394 363.486 243.096 366.353C244.185 370.799 245.564 378.892 243.831 386.714'
        stroke='#002346'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M236.743 301.664C236.743 301.664 206.46 323.571 216.769 382.848'
        stroke='#002346'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M171.021 343.546C171.021 343.546 210.969 342.901 212.258 382.205'
        stroke='#002346'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  </div>
  );
};

export default LeftImage;
